<div class="container h-100">
  <div *ngIf="isLoading" class="row h-100 justify-content-center align-items-center">
    <div class="text-center">
      <app-loading-spinner></app-loading-spinner>
    </div>
  </div>
  <div class="row justify-content-center align-items-center VerticalMargin mb-5">
    <div class="card RegularForm rounded col-12 col-lg-9" 
      [class.SmallArabicFont]="globalService.isRTL == true">
      <div class="card-body MyCardBody rounded-bottom" *ngIf="formNotFound == true">
        <div class="text-center" [class.SmallArabicFont]="globalService.isRTL == true">
          <h4>{{ globalService.Get("NODATA") }}</h4>
        </div>
      </div>
      <div class="card-body MyCardBody rounded-bottom" *ngIf="formExpired == true">
        <div class="text-center mt-4" [class.SmallArabicFont]="globalService.isRTL == true">
          <h4>{{ globalService.Get("FORM_EXPIRED") }}</h4>
        </div>
      </div>      
      <div class="card-body MyCardBody rounded-bottom">
        <div class="row"
          *ngIf="(isLoading==false) && (user || user == '') && (csForm.action != 6) && (memberSelection == true)">
          <div class="form-group col-12 col-md-6">
            <label for="forMember">{{ globalService.Get("SELECT_MEMBER") }}</label>
            <select id="forMember" class="form-control" [class.classicRTL]="globalService.isRTL == true"
              [class.classic]="globalService.isRTL == false" (change)="changingMember($event.target.selectedIndex)">
              <option *ngFor="let member of members; index as i" [ngValue]="member.id" [selected]="i == 0">
                {{ member.firstName }} {{ member.lastName }}
              </option>
              <!-- <option [ngValue]="0">{{ globalService.Get("OTHER") }}</option> -->
            </select>
          </div>
          <br>
        </div>
        <div class="col-12" *ngIf="pictureUrl != '' && pictureUrl != null"
          [class.text-right]="globalService.isRTL == true">
          <div class="form-group text-center">
            <img [src]="pictureUrl" class="img-fluid fitimage mb-2" /><br />
          </div>
          <br>
        </div>
        <div class="fb-render text-dark"></div>
        <div class="row mt-4" *ngIf="error!=''">
          <div class="col-12">
            <ngb-alert [type]="'primary'" class="text-center" (close)="error = ''"
              [class.ArabicFont]="globalService.isRTL == true">
              {{ error }}
            </ngb-alert>
          </div>
        </div>
        <div class="row mt-4" *ngIf="confirmation!=''">
          <div class="col-12">
            <ngb-alert [type]="'success'" class="text-center" (close)="confirmation = ''"
              [class.ArabicFont]="globalService.isRTL == true">
              {{ confirmation }}
            </ngb-alert>
          </div>
        </div>
        <div class="row" [class.mt-4]="(error == '') && (confirmation == '')"
          *ngIf="(isLoading==false) && (csForm.noSubmitButton == false) && (formNotFound == false) && (formExpired == false)">
          <div class="col-12">
            <button class="btn btn-block btn-primary" [disabled]="submitted" type="button" (click)="submit()">
              <span *ngIf="saving == true"> <i class="fas fa-spinner fa-spin"></i> </span>
              <span *ngIf="saving == false"> {{ buttonName }} </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>